<template>
    <div class="record-content-box">
        <div class="record-content">
            <div class="record-search">
                <div class="search-l">
                    <p class="title">协作记录</p>
                </div>
                <div class="search-r">
                    <Input prefix="ios-search" v-model="recordParams.search" placeholder="搜索发起人或参与成员" style="width: 296px;margin-right: 18px" />
                    <Button class="left-btn" @click="onReset">重置</Button>
                    <Button type="primary" class="left-btn" @click="onSearch">搜索</Button>
                </div>
            </div>
            <div class="record-list">
                <Table stripe="stripe" :height="recordListHeight" :loading="recordLoading" :columns="recordListColumns" :data="recordArray.content">
                    <template slot-scope="{ row }" slot="发起人">
                        {{ row.initiatorName }}
                    </template>
                    <template slot-scope="{ row }" slot="参与成员">
                        <div class="member-box"><span :key="key" v-for="(user,key) in (row.memberNameList.length>3?row.memberNameList.slice(0,3):row.memberNameList)">{{ user }}{{ key!==((row.memberNameList.length>3?row.memberNameList.slice(0,3):row.memberNameList).length-1)?'、':'' }}</span>{{ row.memberNameList.length>3?'...':'' }}</div>
                    </template>
                    <template slot-scope="{ row }" slot="开始时间">
                      {{ row.startTime.replace(/:..$/, '') }}
                    </template>
                    <template slot-scope="{ row }" slot="结束时间">
                      {{ row.finishTime.replace(/:..$/, '') }}
                    </template>
                    <template slot-scope="{ row }" slot="操作">
                        <Tooltip content="查看" placement="top">
                            <a class="btn blue" href="javascript:" @click="onLookVideoInfo(row)"><Icon type="md-eye" :size="20"/></a>
                        </Tooltip>
                        <Tooltip content="视频" placement="top">
                            <a class="btn blue" href="javascript:" v-if=" row.videoList.length!==0" @click="onLookVideo(row)"><Icon custom="record-icon-video" :size="20"/> {{ row.videoList.length }}</a>
                        </Tooltip>
                        <Tooltip content="删除" placement="top">
                            <a class="btn" href="javascript:" @click="onDelete(row.id)"><Icon type="ios-trash" :size="22"/></a>
                        </Tooltip>
                    </template>
                </Table>
            </div>
        </div>
        <div class="record-list-page" v-if="recordArray.content && recordArray.content.length !== 0">
            <Page :total="recordArray.totalSize" :current="recordParams.currentPage" show-total show-sizer size="small" :page-size="recordParams.displayNumber" @on-change="onSearchPage" @on-page-size-change="onSearchPageSize"/>
        </div>
        <Modal
            v-model="quickVideoInfoVisible"
            title="记录详情"
            width="420"
            class-name="record-modal"
            footer-hide>
            <div class="record-modal-info">
                <h2 class="title">由{{ quickVideoInfo.initiatorName }}专家发起的远程协作</h2>
                <div class="user">
                    <div class="user-list">
                        <span :key="key" v-for="(user,key) in quickVideoInfo.memberNameList">{{ user }}{{ key!==quickVideoInfo.memberNameList.length-1?'、':'' }}</span>
                    </div>
                    <div class="user-number" v-if="JSON.stringify(quickVideoInfo)!=='{}'">
                        <Icon custom="user-icon"/>{{ quickVideoInfo.memberNameList.length }}人参会
                    </div>
                </div>
                <p class="time" v-if="JSON.stringify(quickVideoInfo)!=='{}'">开始时间：{{ quickVideoInfo.finishTime.replace(/:..$/, '') }} / 结束时间：{{ quickVideoInfo.startTime.replace(/:..$/, '') }}</p>
            </div>
        </Modal>
        <Modal
            v-model="quickVideoVisible"
            :title="'协作录像（'+quickNumber+'/'+quickUserList.length+'）'"
            width="500"
            class-name="record-modal"
            @on-visible-change="onVisiblePlayChange"
            footer-hide>
            <div class="record-video-modal">
                <span class="label" v-if="quickUserList.length!==0">{{ quickUserList[quickNumber-1].recordingUserName }}</span>
                <div class="image-list">
                    <a href="javascript:" v-if="quickUserList.length >1" class="image-l" @click="onPreviousPage('video')"><Icon size="26" type="ios-arrow-back" /></a>
                    <a href="javascript:" v-if="quickUserList.length >1" class="image-r" @click="onNextPage('video')"><Icon size="26" type="ios-arrow-forward" /></a>
                    <div class="image-box">
                        <div class="image-content" :style="'width:'+(428*quickUserList.length)+'px; transform: translate3d(-'+(428*(quickNumber-1))+'px,0px,0px)'">
                            <div class="video-box" :key="key" v-for="(pictureRecording,key) in quickUserList">
                                <video :ref="'recordVideo'+key" width="100%" height="100%" controls :autoplay="false" :src="pictureRecording.videoUrl"/>
                            </div>
                        </div>
                    </div>
                </div>
          </div>
        </Modal>
    </div>
</template>
<script>
import Collaboration from './list'
export default Collaboration
</script>
<style lang="less">
@import "list";
</style>
